import { POST } from "../../index";

export const selectCarDayOverview = (param) => POST("/v1/customizeHomePage/selectCarDayOverview", param);
export const selectDriverOverview = (param) => POST("/v1/customizeHomePage/selectDriverOverview", param);
export const selectDriverWorkRank = (param) => POST("/v1/customizeHomePage/selectDriverWorkRank", param);
export const selectCompanyCar = (param) => POST("/v1/customizeHomePage/selectCompanyCar", param);
export const selectCompanyDriver = (param) => POST("/v1/customizeHomePage/selectCompanyDriver", param);
export const selectCompanyWorkRank = (param) => POST("/v1/customizeHomePage/selectCompanyWorkRank", param);
export const selectCityCar = (param) => POST("/v1/customizeHomePage/selectCityCar", param);